export default __webpack_public_path__ + "static/media/Sand-Trap.be10b578.jpg";